import { useParams, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import * as Icons from "lucide-react";
import categorias from "@/data/categorias.json";
import { getSalmosPorSituacoes } from "@/lib/salmos";
import { useLang } from "@/lib/i18n";
import SalmoCard from "@/components/SalmoCard";
import OrnamentoDourado from "@/components/OrnamentoDourado";
import SEO from "@/components/SEO";

export default function CategoriaPage() {
  const { slug } = useParams();
  const { t } = useLang();
  const categoria = categorias.find((c) => c.slug === slug);

  if (!categoria) {
    return (
      <div className="px-6 py-32 text-center">
        <div className="font-display text-3xl text-[var(--cor-texto)]">404</div>
        <Link to="/" className="mt-8 inline-block font-display text-sm uppercase tracking-[0.22em] text-[var(--cor-dourado)] border border-[var(--cor-dourado)]/40 px-8 py-3 rounded-full">{t.voltar_inicio}</Link>
      </div>
    );
  }

  const Icone = Icons[categoria.icone] || Icons.Sparkles;
  const salmos = getSalmosPorSituacoes(categoria.situacoes);

  return (
    <div className="mx-auto max-w-6xl px-6 py-12" data-testid="categoria-page">
      <SEO
        title={`${categoria.label} — ${t.salmos} | salmos.pt`}
        description={categoria.descricao}
      />

      <nav className="flex items-center gap-2 font-display text-[10px] uppercase tracking-[0.22em] text-[var(--cor-texto-2)]" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-[var(--cor-dourado-claro)]">{t.inicio}</Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-[var(--cor-dourado)]">{categoria.label}</span>
      </nav>

      <header className="text-center mt-16">
        <Icone className="h-12 w-12 text-[var(--cor-dourado)] mx-auto" strokeWidth={1.2} />
        <div className="font-display text-[10px] uppercase tracking-[0.32em] text-[var(--cor-dourado)] mt-6">{t.por_situacao}</div>
        <h1 className="font-display text-5xl md:text-6xl text-[var(--cor-texto)] mt-4 font-light leading-tight">
          {categoria.label}
        </h1>
        <p className="font-serif italic text-[var(--cor-texto-2)] mt-6 text-lg max-w-xl mx-auto">{categoria.descricao}</p>
        <OrnamentoDourado className="mt-10" />
      </header>

      <div className="mt-16 flex flex-wrap gap-2 justify-center" data-testid="outras-categorias">
        {categorias.filter((c) => c.slug !== slug).map((c) => (
          <Link
            key={c.slug}
            to={`/categoria/${c.slug}`}
            className="font-display text-xs uppercase tracking-[0.22em] text-[var(--cor-texto-2)] border border-[var(--cor-borda)] px-5 py-2 rounded-full hover:border-[var(--cor-dourado)]/50 hover:text-[var(--cor-dourado-claro)] transition-all"
          >
            {c.label}
          </Link>
        ))}
      </div>

      <div className="mt-20 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {salmos.length === 0 ? (
          <div className="col-span-full text-center font-serif italic text-[var(--cor-texto-2)]">{t.nenhum_salmo}</div>
        ) : (
          salmos.map((s) => <SalmoCard key={s.numero} salmo={s} />)
        )}
      </div>
    </div>
  );
}
